import Footer from "../Homepages/Footer";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

export default function Video() {
  const navigate = useNavigate();
  const select = [
    "Pranks",
    "Cat Videos",
    "Dog Videos",
    "Joke",
    "Dance",
    "Roast",
    "Gags",
    "Skits",
    "TikTok",
    "Stunts",
    "Drama",
    "Celebrity",
    "Pop Culture",
    "Politics",
    "Sports",
    "Motivational",
  ];
  const onClick = (e) => {
    e.target.classList.toggle("mystyle");
  };

  return (
    <div className="container px-4 mb-5">
      <div className="heading mb-3 mt-4">
        <BsArrowLeft
          size="30px"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/home");
          }}
        />
        <h3 className="text-center no-wrap">Happiness Island</h3>
      </div>
      <div className="container mb-5">
        <h4>Welcome to Happiness Island</h4>
        <h1 style={{ fontWeight: "bolder", fontSize: "35px" }} className="my-4">
          Select the type of content you like to see
        </h1>
        <div className="affs">
          {select.map((each, index) => {
            return (
              <h6
                key={index}
                style={{color:"#000"}}
                className="aff"
                onClick={(e) => {
                  onClick(e);
                }}
              >{each}</h6>
            );
          })}
        </div>
      </div>
      <div className="d-flex justify-content-end mb-5">
        <button
          className="btnSave mb-5"
          type="submit"
          onClick={() => {
            navigate("/video/videos");
          }}
        >
          Submit
        </button>
      </div>
      <Footer />
    </div>
  );
}
